export default {
  ceilWaveLine: {
    id: -1,
    forceRule: {
      type: 'tfx.ceilWaveLine',
      duration: 1e3,
      position: ['center', 'center'],
      distance: 100
    }
  },
  gradientFade: {
    id: -1,
    forceRule: {
      type: 'gradientFade',
      duration: 1e3,
      begin: 0,
      direction: 'left'
    }
  },
  gradientHide: {
    id: -1,
    forceRule: {
      type: 'gradientHide',
      duration: 1e3,
      begin: 0,
      direction: 'left'
    }
  },
  slide: {
    id: -1,
    forceRule: {
      type: 'slide',
      duration: 1e3,
      begin: 0,
      distance: 600,
      position: [0, 0],
      angle: 0
    }
  },
  slideHorizon: {
    id: -1,
    forceRule: {
      type: 'slideHorizon',
      duration: 1e3,
      begin: 0,
      distance: 600,
      position: [0, 0],
      angle: 0
    }
  },
  circle: {
    id: -1,
    forceRule: {
      type: 'circle',
      duration: 1e3,
      begin: 0,
      position: [0, 0],
      reverse: false
    }
  },
  gaussianBlur: {
    id: -1,
    forceRule: {
      type: 'gaussianBlur',
      duration: 1e3,
      begin: 0,
      radius: 10,
      reverse: false,
      mode: 'gradient'
    }
  },
  middleOnBothSides: {
    id: -1,
    forceRule: {
      type: 'middleOnBothSides',
      duration: 1e3,
      begin: 0,
      reverse: false,
      direction: 'lr'
    }
  },
  flutter: {
    id: -1,
    forceRule: {
      type: 'tfx.flutter',
      duration: 1e3,
      begin: 0,
      distance: 0,
      angle: 0,
      is_fade: false
    }
  },
  rowFlutter: {
    id: -1,
    forceRule: {
      type: 'tfx.rowFlutter',
      duration: 1e3,
      begin: 0,
      distance: 100,
      angle: 0
    }
  },
  slideDrictionShow: {
    id: -1,
    forceRule: {
      type: 'tfx.slideDrictionShow',
      duration: 1e3,
      begin: 0,
      distance: 100,
      angle: 0,
      mirror_distance: 100,
      mirror_angle: 0
    }
  },
  scale: {
    id: -1,
    forceRule: {
      type: 'scale',
      duration: 1e3,
      begin: 0,
      reverse: false,
      percent_width: .5,
      scale_mode: 'center'
    }
  }
};

export const effectParams = {
  gradientFade: {
    direction: 'left'
  },
  gradientHide: {
    direction: 'left'
  },
  ceilWaveLine: {
    distance: 100
  },
  slide: {
    distance: 600,
    angle: 0
  },
  slideHorizon: {
    distance: 600,
    angle: 0
  },
  circle: {
    reverse: false
  },
  gaussianBlur: {
    radius: 10,
    reverse: false,
    mode: 'gradient'
  },
  middleOnBothSides: {
    reverse: false,
    direction: 'lr'
  },
  flutter: {
    distance: 0,
    angle: 0,
    is_fade: false
  },
  rowFlutter: {
    distance: 100,
    angle: 0
  },
  slideDrictionShow: {
    distance: 100,
    angle: 0,
    mirror_distance: 100,
    mirror_angle: 0
  },
  scale: {
    percent_width: .5,
    reverse: false
  }
};

export const effectParamDescs = {
  gradientFade: [
    {
      tag: 'LabelOption',
      prop: 'direction',
      attrs: {
        label: '方向',
        optionList: [
          { name: '上', value: 'top' },
          { name: '右', value: 'right' },
          { name: '下', value: 'bottom' },
          { name: '左', value: 'left' }
        ]
      }
    }
  ],
  gradientHide: [
    {
      tag: 'LabelOption',
      prop: 'direction',
      attrs: {
        label: '方向',
        optionList: [
          { name: '上', value: 'top' },
          { name: '右', value: 'right' },
          { name: '下', value: 'bottom' },
          { name: '左', value: 'left' }
        ]
      }
    }
  ],
  ceilWaveLine: [
    {
      tag: 'LabelInput',
      attrs: {
        max: 1e3,
        label: '距离'
      },
      prop: 'distance'
    }
  ],
  slide: [
    {
      tag: 'LabelInput',
      attrs: {
        label: '距离',
        min: 0
      },
      prop: 'distance'
    },
    {
      tag: 'LabelInput',
      attrs: {
        deg: true,
        label: '角度'
      },
      prop: 'angle'
    }
  ],
  slideHorizon: [
    {
      tag: 'LabelInput',
      attrs: {
        label: '距离',
        min: 0
      },
      prop: 'distance'
    },
    {
      tag: 'LabelInput',
      attrs: {
        deg: true,
        label: '角度'
      },
      prop: 'angle'
    }
  ],
  circle: [{
    tag: 'LabelSwitch',
    prop: 'reverse',
    attrs: {
      label: '反向播放'
    }
  }],
  gaussianBlur: [
    {
      tag: 'LabelInput',
      prop: 'radius',
      attrs: {
        label: '模糊半径',
        min: 0
      }
    },
    {
      tag: 'LabelSwitch',
      prop: 'reverse',
      attrs: {
        label: '反向播放'
      }
    }
    // {
    //   tag: 'LabelOption',
    //   prop: 'mode',
    //   attrs: {
    //     label: '类型',
    //     optionList: [
    //       { name: '静态', value: 'normal' },
    //       { name: '动态', value: 'gradient' }
    //     ]
    //   }
    // }
  ],
  middleOnBothSides: [
    {
      tag: 'LabelSwitch',
      prop: 'reverse',
      attrs: {
        label: '反向播放'
      }
    },
    {
      tag: 'LabelOption',
      prop: 'direction',
      attrs: {
        label: '方向',
        optionList: [
          { name: '左右', value: 'lr' },
          { name: '上下', value: 'bt' }
        ]
      }
    }
  ],
  flutter: [
    {
      tag: 'LabelInput',
      attrs: {
        label: '距离',
        min: 0
      },
      prop: 'distance'
    },
    {
      tag: 'LabelInput',
      attrs: {
        deg: true,
        label: '角度'
      },
      prop: 'angle'
    },
    {
      tag: 'LabelSwitch',
      prop: 'is_fade',
      attrs: {
        label: '淡入'
      }
    }
  ],
  rowFlutter: [
    {
      tag: 'LabelInput',
      attrs: {
        label: '距离',
        min: 0
      },
      prop: 'distance'
    },
    {
      tag: 'LabelInput',
      attrs: {
        deg: true,
        label: '角度'
      },
      prop: 'angle'
    }
  ],
  slideDrictionShow: [
    {
      tag: 'LabelInput',
      attrs: {
        label: '距离',
        min: 0
      },
      prop: 'distance'
    },
    {
      tag: 'LabelInput',
      attrs: {
        deg: true,
        label: '角度'
      },
      prop: 'angle'
    },
    {
      tag: 'LabelInput',
      attrs: {
        max: 1e3,
        label: '第二滑动距离',
        min: 0
      },
      prop: 'mirror_distance'
    },
    {
      tag: 'LabelInput',
      attrs: {
        deg: true,
        label: '第二滑动角度'
      },
      prop: 'mirror_angle'
    }
  ],
  scale: [
    {
      tag: 'LabelInput',
      attrs: {
        label: '缩放比例',
        min: 0,
        max: 10
      },
      prop: 'percent_width'
    },
    {
      tag: 'LabelSwitch',
      prop: 'reverse',
      attrs: {
        label: '反向播放'
      }
    }
  ]
};